import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
const thisyear=dayjs().format('YYYY')
const nextyear=dayjs().add(1,'year').format('YYYY')

function TDerived($Type){		
	let TM=[]
	let HM=''
	let TT=''
	let FMT=''
	let Dates=''
	let alphabet=[]
	if($Type==="YB") {
		HM=80
		TT='year'
		FMT='YYYY'
		Dates=dayjs().subtract(18,'year').format('YYYY-MM-DD')
	} else if($Type==="Y") {
		HM=80
		TT='year'
		FMT='YYYY'
		Dates=dayjs().format('YYYY-MM-DD')
	} else if($Type==="M") {
		HM=12
		TT='month'
		FMT='MM'
		Dates=dayjs('2021-12-31').format('YYYY-MM-DD')
	} else if($Type==="D") {
		HM=31
		TT='day'
		FMT='DD'
		Dates=dayjs('2021-01-31').format('YYYY-MM-DD')
	} else if($Type==="P1") {
		HM=10
		TT='day'
		FMT='D'
		Dates=dayjs('2021-01-01').format('YYYY-MM-DD')
	} else if($Type==="PC") {
		const alpha = Array.from(Array(26)).map((e, i) => i + 65);
		alphabet = alpha.map((x) => String.fromCharCode(x));
	}
	
	for(let $i=0;$i<HM;$i++) {
		if($Type==="P1") {
			TM.push($i)
		} else {
			TM[$i]=dayjs(Dates).subtract($i,TT).format(FMT)
		}
	}
	if($Type==="PC") {
	 return alphabet
	} else {return TM;}
}
class NewApplication extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {ftpprocess:'',days:dayjs().format('MM/DD/YYYY'),Appstatus:'APPROVED',CompName:'',NewApp:[],user:localStorage.getItem('tokens'),
						profileinfo:[],Resp:'',newapps:'', appdecline:'',approvedloan:'',payschedules:'', datein1:'',datein2:'',datein3:'', NLoan:'',NSFCase:'',
						ClientPay:[], ClientPayStatus:'', PayNames:'',ContFIN:'', ContTransit:'', ContCHECK:'', CCID:'',CPDSDAY:'',CFTPDAY:'',
						Contpayment:'',payday:'',contact:'',ContEamil:'',phone:'',PaySimplii:'', Day1:'',SpecaiPay:'',Specials:[]};							
		this.handleAPPChange=this.handleAPPChange.bind(this)		
		this.handleChange=this.handleChange.bind(this)	
		this.handlePaySimpliiChange=this.handlePaySimpliiChange.bind(this)
		this.handleSubmit=this.handleSubmit.bind(this)
	}
	componentDidMount() {	
		const para={user:this.state.user}
		axios.post(process.env.REACT_APP_API_ENV+'api/individualftpcases.php')
			.then(result => {				
				if(result.data[0][0] === "No") {
					this.setState({Resp:"No Approved Loan yet"})					
				} else {
					this.setState({Resp:""})
					this.setState({NewApp:result.data})					
				}
			})
		axios.post(process.env.REACT_APP_API_ENV+'api/ftpcases.php')
			.then(result => {								
				this.setState({Resp:""})
				this.setState({NLoan:result.data})					
				
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/clientPayment.php')
			.then(result => {				
				if(result.data[0][0] === "No") {
					this.setState({ClientPayStatus:"1"})					
				} else {					
					this.setState({ClientPay:result.data})
					this.setState({ClientPayStatus:result.data[0][12]})
					this.setState({PayNames:result.data[0][9]})						
				}
			})
		axios.post(process.env.REACT_APP_API_ENV+'api/SpecialPayDetails.php')
			.then(result => {				
				if(result.data[0][0] == "No") {
					this.setState({SpecaiPay:""})					
				} else {
					this.setState({SpecaiPay:result.data[0][10]})
					this.setState({Specials:result.data})						
				}
			})
		axios.post(process.env.REACT_APP_API_ENV+'api/nsfcases.php')
			.then(result => {								
				this.setState({NSFCase:result.data})									
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})			
	}
	handleChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})
	}

	handleAPPChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})			
		const userObject = {	
				PID:this.state.NewApp.filter(sub=>sub[0] === event.target.value).map(sub=>sub[1])[0],				
				AID:this.state.NewApp.filter(sub=>sub[0] === event.target.value).map(sub=>sub[0])[0],
			 }
		axios.post(process.env.REACT_APP_API_ENV+'api/applicationinfo.php',userObject)
			.then(result => {						
				this.setState({profileinfo:result.data})				
			})					
	}
	
	handlePaySimpliiChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})
		this.setState({ContFIN: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[1])[0]})		
		this.setState({ContTransit: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[2])[0]})
		this.setState({ContCHECK: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[3])[0]})
		this.setState({Contpayment: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[4])[0]})
		this.setState({payday: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[11])[0]})
		this.setState({contact: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[6])[0]})
		this.setState({ContEamil: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[8])[0]})
		this.setState({phone: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[7])[0]})
		this.setState({PaySimplii: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[9])[0]})
		this.setState({Day1: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[13])[0]})
		this.setState({CFTPDAY: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[16])[0]})
		this.setState({CCID: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[17])[0]})
		this.setState({CPDSDAY: this.state.ClientPay.filter(sub=>sub[0]==event.target.value).map(sub=>sub[18])[0]})
	}	
	
	handleSubmit = event => {
		event.preventDefault()		
		const {ftpprocess,newapps, appdecline,approvedloan,payschedules, datein1,datein2,datein3,Contpayment,CCID,CFTPDAY,CPDSDAY} = this.state			
		if(!ftpprocess){
			alert('Please select FTP process')
			return false
		} else if(ftpprocess == '2'){
			if(!appdecline){
				alert('Please select FTP process')
				return false
			} else if(appdecline === '1'){
				if(!approvedloan){
					alert('Please select morning or afternoon run')
					return false 
				} 
				if(!payschedules){
					alert('Please select FTP PAD or PDS process')
					return false 
				} 
			} else if(appdecline === '2'){		
				if(!approvedloan){
					alert('Please select morning or afternoon run')
					return false 
				} 
				if(!datein1){
					alert('Please select to regenerate which year FTP file')
					return false 
				} 
				if(!datein2){
					alert('Please select to regenerate which month FTP file')
					return false 
				} 
				if(!datein3){
					alert('Please select to regenerate which day FTP file')
					return false 
				} 
				if(!payschedules){
					alert('Please select FTP PAD or PDS process')
					return false 
				} 			
			} else if(appdecline === '3'){		
				if(!approvedloan){
					alert('Please select morning or afternoon run')
					return false 
				} 
				if(!datein1){
					alert('Please select to download which year FTP file')
					return false 
				} 
				if(!datein2){
					alert('Please select to download which month FTP file')
					return false 
				} 
				if(!datein3){
					alert('Please select to download which day FTP file')
					return false 
				} 
				if(!payschedules){
					alert('Please select FTP PAD or PDS file')
					return false 
				} 	
			} 
			const userObject = {	
				user:this.state.user,			
				Appstatus: this.state.Appstatus,
				appdecline: this.state.appdecline,
				approvedloan: this.state.approvedloan,							
				payschedules: this.state.payschedules,
				datein1: this.state.datein1,
				datein2: this.state.datein2,
				datein3:this.state.datein3			
			};
			if(appdecline === '1'||appdecline === '2'){	
				axios.post(process.env.REACT_APP_API_ENV+'api/approveprocess.php', userObject)
					.then((res) => {
						this.setState({Resp:res.data})											
					}).catch((error) => {
						console.log(error)
					});
			} else if (appdecline === '3') {			
				const downloadfile=this.state.payschedules+this.state.datein1+this.state.datein2+this.state.datein3+this.state.approvedloan+'.txt'
				axios.post(process.env.REACT_APP_API_ENV+'api/checkfile.php', {downloadfile:downloadfile})
					.then(res => {														
						this.setState({Resp:res.data})		
						if(res.data === 'Yes') {	
							this.setState({Resp:''})	
							fetch(process.env.REACT_APP_API_ENV+"api/downloadFTP.php?ftpfile="+downloadfile)
								.then(res => res.blob())
								.then(blob => saveAs(blob, downloadfile))	
						} 
					})
				
			}	
		} else if(ftpprocess == '3'){			 
			if(!appdecline){
				alert('Please select client')
				return false 
			} 
			if(!approvedloan){
				alert('Please check whether payment is returned or complete')
				return false 
			} 
			const userObject = {	
				user:this.state.user,			
				Appstatus: this.state.Appstatus,
				ftpprocess: this.state.ftpprocess,
				appdecline: this.state.appdecline,
				ContFIN: this.state.ContFIN,
				ContTransit: this.state.ContTransit,
				ContCHECK: this.state.ContCHECK,
				Contpayment: this.state.Contpayment,
				payday: this.state.payday,
				contact: this.state.contact,
				ContEamil: this.state.ContEamil,
				phone: this.state.phone,
				PaySimplii: this.state.PaySimplii,
				Day1: this.state.Day1,
				approvedloan: this.state.approvedloan,
				CFTPDAY: this.state.CFTPDAY,
				CPDSDAY: this.state.CPDSDAY,
				CCID: this.state.CCID
			};
			axios.post(process.env.REACT_APP_API_ENV+'api/approveprocess.php', userObject)
				.then((res) => {
					this.setState({Resp:res.data})											
				}).catch((error) => {
					console.log(error)
				});			
		} else if(ftpprocess == '1'){			 			
			const userObject = {	
				user:this.state.user,			
				Appstatus: this.state.Appstatus,
				ftpprocess: this.state.ftpprocess,
				applicationid: this.state.newapps								
			};
			axios.post(process.env.REACT_APP_API_ENV+'api/approveprocess.php', userObject)
				.then((res) => {
					this.setState({Resp:res.data})											
				}).catch((error) => {
					console.log(error)
				});			
		} else if(ftpprocess == '4'){			 
			if(!appdecline){
				alert('Please select client')
				return false 
			} 
			if(!approvedloan){
				alert('Please check whether payment is returned or complete')
				return false 
			} 
			const userObject = {	
				user:this.state.user,			
				Appstatus: this.state.Appstatus,
				ftpprocess: this.state.ftpprocess,
				appdecline: this.state.appdecline,				
				approvedloan: this.state.approvedloan,
				CFTPDAY: this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[8]),
				CPDSDAY: this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[6]),
				Contpayment:this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[17])
			};
			axios.post(process.env.REACT_APP_API_ENV+'api/approveprocess.php', userObject)
				.then((res) => {
					this.setState({Resp:res.data})											
				}).catch((error) => {
					console.log(error)
				});			
		}
	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Payday Loan Application"/>				
				<label><b>{this.state.SpecaiPay != "" ? this.state.SpecaiPay+' and ':''} FTP Banking Files {'(There are '+this.state.NLoan+' ftp cases)'}</b></label><br/>
				<select id="ftpprocess" name="ftpprocess" style={{width: '150px', border:'1px solid grey'}} value = {this.state.ftpprocess} onChange={this.handleChange}>
					<option value="">--Select--</option>
					<option value="1">Individual Approved Loan Process</option>
					<option value="2">FTP Process--Daily Process</option>
					{(()=>{if(this.state.PayNames != "") {return (						
						<option value="3">{this.state.PayNames} Client Payment Status</option>	
					)}})()}
					{(()=>{if(this.state.SpecaiPay != "") {return (						
						<option value="4">Special Payment Setup</option>	
					)}})()}
				</select><br/>
				<label>{this.state.NLoan == 0 ? 'You can download PAD/PDS file by selecting FTP Process--Daily Process':'If 6 or less approved loans, suggest manual operation using RBC Express due to expense'}</label><br/><br/>				
				<label><b>Please process PaySimplii Client Payment Status first before FTP Process</b></label><br/><br/>
				<ol style={{textAlign:'left'}}>
				<li>Check Payment Returned</li>
				<li>Check Confirm PaySimplii Client Payment</li>
				<li>Check Payment Complete</li>
				<li>Without Payment Complete process, salary can't be deposited into employee account</li><br/><br/>
				</ol>
				{(()=>{if(this.state.ftpprocess === "1") {return (<div>	
					<form onSubmit={this.handleSubmit}>
						<label><b>Please Select Application ID:</b></label><br/>
						<select id="newapps" name="newapps" style={{width: '150px', border:'1px solid grey'}} value = {this.state.newapps} onChange={this.handleAPPChange}>
							<option value="">--Select Application ID--</option>		
							{this.state.NewApp.map(item => (<option value={item[0]} key={item[0]}>{item[0]}</option>))}								
						</select><br/><br/>		
						{(()=>{if(this.state.NewApp.filter(item=>item[0]==this.state.newapps).map(item=>item[11])=="Cashhub") {return (<div>	
							Since this application is from Cashhub, no profile can be populated.
						</div>)} else if(this.state.NewApp.filter(item=>item[0]==this.state.newapps).map(item=>item[11])=="PaySimplii") {return (<div>
							Since this application is from PaySimplii, no profile can be populated.
						</div>)} else if(this.state.NewApp.filter(item=>item[0]==this.state.newapps).map(item=>item[11])=="Loan2U") {return (<div>									
							<h3>Approve Loan Information</h3><br/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>First Name:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[1]} readOnly/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Last Name:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[2]} readOnly/><br/>							
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Bank Name:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[30]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>FIN #:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[32]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Branch Transit:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[31]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Check Number:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[10]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Debit Card #:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[11]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Online PWD:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[12]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Security Question 1:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[33]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Question 1 Answer:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[34]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Security Question 2:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[35]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Question 2 Answer:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[36]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Security Question 3:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[37]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Question 3 Answer:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[38]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Security Question 4:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[39]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Question 4 Answer:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[40]} readOnly/><br/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Security Question 5:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[41]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Question 5 Answer:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.profileinfo[42]} readOnly/><br/>								
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>First Pay Day:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[3])[0]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Second Pay Day:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[4])[0]} readOnly/><br/>											
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Profile ID:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[1])[0]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>AccountID:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[0])[0]} readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Approved Loan:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[5])[0]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Approved Loan Cost:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[6])[0]}readOnly/><br/>				
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Approved Date:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[7])[0]} readOnly/>
							<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Scheduled Pay Day:</b></label>
							<input type="text" name="address" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.NewApp.filter(sub=>sub[0] === this.state.newapps).map(sub=>sub[8])[0]} readOnly/><br/><br/>					
							<label style={{width: '600px',display:'inline-block',textAlign:'center'}}>Please manually create payment in RBC Express.</label><br/><br/>
							
							<h3>{this.state.Resp}</h3><br/><br/>
							<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Update {this.state.newapps} in Database</button><br/><br/>
						</div>)}})()}
					</form>
				</div>)} else if(this.state.ftpprocess === "2") {return (<div>	
					<form onSubmit={this.handleSubmit}>
						<label><b>FTP Process</b></label><br/>
						<select id="appdecline" name="appdecline" style={{width: '150px', border:'1px solid grey'}} value = {this.state.appdecline} onChange={this.handleChange}>
							<option value="">--Select--</option>		
							<option value="1">Generate FTP File</option>		
							<option value="2">Re-generate FTP File</option>									
							<option value="3">Download FTP File</option>		
						</select><br/><br/>	
						{(()=>{if(this.state.appdecline === "1") {return (<div>								
								<label ><b>Run Time</b></label><br/>
								<select id="approvedloan" name="approvedloan" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.approvedloan} onChange={this.handleChange}>
									<option value="">--Select--</option>		
									<option value="1">Morning Run (before 1pm)</option>		
									<option value="2">Afternoon Run (after 1pm)</option>		
								</select><br/><br/>
								<label ><b>Run Type</b></label><br/>
								<select name="payschedules" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.payschedules} onChange={this.handleChange}>									
									<option value="">--select--</option>
									<option value="1">PDS Process</option>
									<option value="2">PAD and PDS Processes</option>									
								</select><br/><br/>											
						</div>)} else if(this.state.appdecline === "2") {return (<div>							
								<label ><b>Re-generate whole day PAD and PDS files</b></label><br/>
								<select id="approvedloan" name="approvedloan" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.approvedloan} onChange={this.handleChange}>
									<option value="">--Select--</option>		
									<option value="3">whole day PAD and PDS file</option>											
								</select><br/><br/>
								<label ><b>Run Date</b></label><br/>																
								<label style={{width: '55px',display:'inline-block',textAlign:'center'}}><small>Year</small></label>
								<label style={{width: '50px',display:'inline-block',textAlign:'center'}}><small>Month</small></label>
								<label style={{width: '55px',display:'inline-block',textAlign:'center'}}><small>Day</small></label><br/>								
								<select style={{width: '55px',border:'1px solid #4195fc'}} name="datein1" value={this.state.datein1} onChange={this.handleChange}>
									<option value="">--</option> 
									<option value={thisyear}>{thisyear}</option> 
									{(()=>{if(dayjs(thisyear).endOf('year').diff(dayjs(),'day') < 61) {return (
										<option value={nextyear}>{nextyear}</option> 				
									)}})()}
								</select>-
								<select style={{width: '44px',border:'1px solid #4195fc'}} name="datein2" value={this.state.datein2} onChange={this.handleChange}>
									<option value="">--</option>
									{TDerived('M').reverse().map(item => (<option value={item.slice(0,4)} key={item.key}>{item.slice(0,4)}</option>))}																		
								</select>-
								<select style={{width: '44px',border:'1px solid #4195fc'}} name="datein3" value={this.state.datein3} onChange={this.handleChange}>
									<option value="">--</option>
									{TDerived('D').reverse().map(item => (<option value={item.slice(0,4)} key={item.key}>{item.slice(0,4)}</option>))}																		
								</select><br/><br/>	
								<label ><b>Run Type</b></label><br/>
								<select name="payschedules" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.payschedules} onChange={this.handleChange}>
									<option value="">--select--</option>
									<option value="1">PDS Process</option>
									<option value="2">PAD and PDS Processes</option>									
								</select><br/><br/>	
						</div>)} else if(this.state.appdecline === "3") {return (<div>
								<label ><b>Run Time</b></label><br/>
								<select id="approvedloan" name="approvedloan" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.approvedloan} onChange={this.handleChange}>
									<option value="">--Select--</option>		
									<option value="1">Morning Run (before 1pm)</option>		
									<option value="2">Afternoon Run (after 1pm)</option>		
									<option value="3">Re-Run</option>	
								</select><br/><br/>
								<label ><b>Run Date</b></label><br/>																
								<label style={{width: '55px',display:'inline-block',textAlign:'center'}}><small>Year</small></label>
								<label style={{width: '50px',display:'inline-block',textAlign:'center'}}><small>Month</small></label>
								<label style={{width: '55px',display:'inline-block',textAlign:'center'}}><small>Day</small></label><br/>								
								<select style={{width: '55px',border:'1px solid #4195fc'}} name="datein1" value={this.state.datein1} onChange={this.handleChange}>
									<option value="">--</option> 
									<option value={thisyear}>{thisyear}</option> 
									{(()=>{if(dayjs(thisyear).endOf('year').diff(dayjs(),'day') < 61) {return (
										<option value={nextyear}>{nextyear}</option> 				
									)}})()}
								</select>-
								<select style={{width: '44px',border:'1px solid #4195fc'}} name="datein2" value={this.state.datein2} onChange={this.handleChange}>
									<option value="">--</option>
									{TDerived('M').reverse().map(item => (<option value={item.slice(0,4)} key={item.key}>{item.slice(0,4)}</option>))}																		
								</select>-
								<select style={{width: '44px',border:'1px solid #4195fc'}} name="datein3" value={this.state.datein3} onChange={this.handleChange}>
									<option value="">--</option>
									{TDerived('D').reverse().map(item => (<option value={item.slice(0,4)} key={item.key}>{item.slice(0,4)}</option>))}																		
								</select><br/><br/>	
								<label ><b>FTP File</b></label><br/>
								<select name="payschedules" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.payschedules} onChange={this.handleChange}>
									<option value="">--select--</option>
									<option value="pds">PDS File</option>
									<option value="pad">PAD File</option>									
								</select><br/><br/>	
						</div>)}})()}
						<h3>{this.state.Resp}</h3><br/><br/>
						<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
					</form>
				</div>)} else if(this.state.ftpprocess == "3") {return (<div>	
					<form onSubmit={this.handleSubmit}>
						<label><b>Check {this.state.PayNames} Client Payment</b></label><br/>						
						<select id="appdecline" name="appdecline" style={{width: '150px', border:'1px solid grey'}} value = {this.state.appdecline} onChange={this.handlePaySimpliiChange}>							
							<option value="">--Select Client--</option>		
							{this.state.ClientPay.map(item => (<option value={item[0]} key={item[0]}>{item[14]}</option>))}													
						</select><br/><br/>	
						{(()=>{if(this.state.appdecline != "") {return (<div>	
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Financial Institution Number:</b></label>							
							<input type="text" name="ContFIN" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[1])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Transit Number:</b></label>
							<input type="text" name="ContTransit" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[2])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Check Account Number:</b></label>
							<input type="text" name="ContCHECK" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[3])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Amount:</b></label>
							<input type="text" name="Contpayment" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[4])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Payment Day:</b></label>
							<input type="text" name="payday" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[11])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Contact:</b></label>
							<input type="text" name="contact" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[6])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Contact Email:</b></label>
							<input type="text" name="ContEamil" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[8])} readOnly/><br/><br/>
							<label style={{width: '250px',display:'inline-block',textAlign:'right'}}><b>Contact Phone:</b></label>
							<input type="text" name="phone" style={{width: '200px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[7])} readOnly/><br/><br/>												
							<label ><b>Check Above Bank Account Payment</b></label><br/>
							<select id="approvedloan" name="approvedloan" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.approvedloan} onChange={this.handleChange}>
								<option value="">--Select--</option>		
								<option value="1">Payment Returned</option>		
								<option value="2">Payment Complete</option>										
								<option value="3">Confirm PaySimplii Client Payment</option>
							</select><br/><br/>
							{(()=>{if(this.state.approvedloan == "1") {return (<div>
								<label ><b>Send Out Following Email</b></label><br/>
								<div style={{width: '500px',textAlign:'center'}}>
								<p style={{textAlign:'left'}}>{"Deal "+this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[6])+", "}<br/><br/>
								{"Due to Non-Sufficient-Fund (toal payment amount $"+this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[4])+") in your payment banking account (FIN="+
								this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[1])+",Transit="+this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[2])+
								",and check no="+this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[3])+
								") which will have impact on your employee salary payment as a whole"}<br/><br/>
								{"Can you please take a look at and make sure your banking account has sufficient fund to pay your employees?"}<br/><br/>
								{"Due to NSF charge by bank, we will charge you $25 for this NSF process as total $"+
								(this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[15]))}<br/><br/>
								Thank you for your cooperation!<br/><br/>
								{this.state.PayNames+" management team!"}
								</p>
								</div>								
							</div>)} else if(this.state.approvedloan == "2") {return (<div>
								<label ><b>Please click Button to update information and generate FTP file together with others</b></label><br/>								
							</div>)} else if(this.state.approvedloan == "3") {return (<div>
								{(()=>{if(this.state.ClientPay.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[19]) == "0") {return (<div>
									<label ><b>This client salary has been cleared, Please go to Payment Complete</b></label><br/>								
								</div>)} else {return (<div>
									<label ><b>Please click Button to confirm client payment complete and process FTP</b></label><br/>								
								</div>)}})()}
							</div>)}})()}							
						</div>)}})()}
						<h3>{this.state.Resp}</h3><br/><br/>
						<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
					</form>
				</div>)} else if(this.state.ftpprocess == "4") {return (<div>	
					<form onSubmit={this.handleSubmit}>
						<label><b>Check Client Payment</b></label><br/>						
						<select id="appdecline" name="appdecline" style={{width: '150px', border:'1px solid grey'}} value = {this.state.appdecline} onChange={this.handleChange}>							
							<option value="">--Select Client--</option>		
							{this.state.Specials.map(item => (<option value={item[0]} key={item[0]}>{item[12] + '-->'+item[9]}</option>))}													
						</select><br/><br/>							
						<label ><b>Check Payment</b></label><br/>
						<select id="approvedloan" name="approvedloan" style={{width: '150px', border:'1px solid grey',marginLeft:'10px'}} value = {this.state.approvedloan} onChange={this.handleChange}>
							<option value="">--Select--</option>		
							<option value="1">Payment Returned</option>		
							<option value="2">Payment Complete</option>					
						</select><br/><br/>
						{(()=>{if(this.state.approvedloan == "1") {return (<div>
							<label ><b>Send Out Following Email</b></label><br/>
							<div style={{width: '500px',textAlign:'center'}}>
							<p style={{textAlign:'left'}}>{"Deal "+this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[6])+", "}<br/><br/>
							{"Due to Non-Sufficient-Fund (toal payment amount $"+this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[4])+") in your banking account (FIN="+
							this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[1])+",Transit="+this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[2])+
							",and check no="+this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[3])+
							") which will have impact on your client payment"}<br/><br/>
							{"Can you please take a look at and make sure your banking account has sufficient fund to pay your employees?"}<br/><br/>
							{"Due to NSF charge by bank, we will charge you $25 for this NSF process as total $"+
							(this.state.Specials.filter(sub=>sub[0]==this.state.appdecline).map(sub=>sub[17]))}<br/><br/>
							Thank you for your cooperation!<br/><br/>
							{this.state.PayNames+" management team!"}
							</p>
							</div>								
						</div>)} else if(this.state.approvedloan == "2") {return (<div>
							<label ><b>If client money is collected successfully, please click Button to update information and generate FTP file together with others</b></label><br/>								
						</div>)}})()}	
						<h3>{this.state.Resp}</h3><br/><br/>
						<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
					</form>
				</div>)}
				})()}
			</div>
		)
	}
}

export default NewApplication